<template>
  <div :class="{'m-nav': true,'m-nav--fixed': isOutofView}" ref="nav">
    <nav>
      <div :class="{active: activeId === allId, 'nav-item': true}"><span @click="changeActive(allId)" class="fz15">全部</span></div>
      <div :class="{active: activeId === eliteId, 'nav-item': true}"><span  @click="changeActive(eliteId)" class="fz15">精华</span></div>
    </nav>
  </div>
</template>

<script>
export default {
  data () {
    return {
      allId: 'all',
      eliteId: 'elite',
      isOutofView: false,
      scrollTop: {
        all: 0,
        elite: 0
      }
    }
  },

  computed: {
    headerHeight () {
      const ratio = this.$store.state.header.ratio
      const height = ratio * document.body.clientWidth
      return height
    }
  },

  props: ['activeId'],

  methods: {
    initEliteList (id) {
      if (id === this.allId || this.$store.state.list.elite.inited) {
        return
      }
      this.$store.dispatch('initEliteList')
    },
    initScrollTop () {
      this.scrollTop.all = this.scrollTop.all === 0 ? this.headerHeight : this.scrollTop.all
      this.scrollTop.elite = this.scrollTop.elite === 0 ? this.headerHeight : this.scrollTop.elite
    },
    changeActive (id) {
      /* 记录浏览的位置 */
      if (id === this.allId) {
        this.scrollTop.elite = document.body.scrollTop
      } else {
        this.scrollTop.all = document.body.scrollTop
      }

      /* 跳到之前的浏览记录 */
      var rect = this.$refs.nav.getBoundingClientRect()
      if (rect.top <= 0) {
        window.setTimeout(() => {
          window.scrollTo(0, Math.max(this.scrollTop[id], this.headerHeight))
        }, 0)
      }

      // 处理计时器
      this.$store.dispatch('handleTimer', {
        oldId: this.activeId,
        newId: id
      })
      this.$store.dispatch('changActiveId', id)
      this.initEliteList(id)
    },

    bindScrollEvent () {
      var onscroll = e => {
        var rect = this.$refs.nav.getBoundingClientRect()
        if (rect.top < 0) {
          this.isOutofView = true
        } else {
          this.isOutofView = false
        }
      }
      window.addEventListener('scroll', onscroll, false)
      window.addEventListener('resize', onscroll, false)
    }
  },

  mounted () {
    this.bindScrollEvent()
    this.initScrollTop()
  }
}
</script>



// WEBPACK FOOTER //
// nav.vue?5016d3ee